import React from 'react';
import { useStyletron } from 'baseui';
import { DataList, Loader } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import noDataImage from '../../../../../assets/userProfile/no-data.webp';
import { defaults } from '../../constants';
import DateRangeFilter from './DateRangeFilter';
import useList from './useList';
import { columnConfigs } from './listConfig';
import {
	containerStyles,
	filterContainerStyles,
	contentContainerStyles,
	cardStyles,
	cardHeaderStyles,
	listItemStyles,
	matchTeamStyles,
	matchVsStyles,
	drawItemStyles,
	drawNumberStyles,
	winningNumberStyles,
	rewardStyles,
	noDataContainerStyles,
	noDataTextStyles
} from './style';

const LotteryWinnersList: React.FC<{}> = () => {
	const { getLotteryWinningsData, handleFilterSubmit, showLoader, forceUpdate, lotteryWinningsData } = useList();
	const [css] = useStyletron();

	return (
		<div className={css(containerStyles)}>
			{showLoader && <Loader />}
			<div className={css(filterContainerStyles)}>
				<DateRangeFilter onSubmit={handleFilterSubmit} />
			</div>

			<div className={css(contentContainerStyles)}>
				{lotteryWinningsData?.data?.length === 0 ? (
					<div className={css(noDataContainerStyles)}>
						<img src={noDataImage} alt='No Data' width={120} height={120} />
						<span className={css(noDataTextStyles)}>No lottery winnings data found for the selected date</span>
					</div>
				) : (
					<>
						<div className={css(cardStyles)}>
							<h3 className={css(cardHeaderStyles)}>Matches</h3>
							{lotteryWinningsData?.meta?.matches.map((match) => (
								<div key={match?.teams[0]?.name} className={css(listItemStyles)}>
									<span className={css(matchTeamStyles)}>{match.teams[0].name}</span>
									<span className={css(matchVsStyles)}>vs</span>
									<span className={css(matchTeamStyles)}>{match.teams[1].name}</span>
								</div>
							))}
						</div>

						<div className={css(cardStyles)}>
							<h3 className={css(cardHeaderStyles)}>Draw Winners</h3>
							{lotteryWinningsData?.meta?.draws.map((draw) => (
								<div key={draw.drawId} className={css(drawItemStyles)}>
									<span className={css(drawNumberStyles)}>Draw #{draw.drawId}</span>
									<span className={css(winningNumberStyles)}>Winning Number: {draw.winningNumber}</span>
									<span className={css(rewardStyles)}>Reward: ₹{draw.poolReward.toLocaleString()}</span>
								</div>
							))}
						</div>

						{lotteryWinningsData?.data?.length > 0 && (
							<DataList
								fetchData={getLotteryWinningsData}
								columnConfigs={columnConfigs}
								entity={LIST_ENTITY_NAMES.CONFISCATION_AND_REFUND}
								globalForceUpdate={forceUpdate}
								filterable={false}
								defaults={defaults}
							/>
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default LotteryWinnersList;
